import React from "react";
import QrCode2OutlinedIcon from "@mui/icons-material/QrCode2Outlined";
import {NodeViewWrapper} from "@tiptap/react";
import type {NodeViewProps} from "@tiptap/react";
import PrintoutBlockShell from "../shared/PrintoutBlockShell";
import QrCodeView from "./QrCodeView";
import {getPrintoutQrCodeAttrs} from "./printoutQrCodeOptions";
import type {PrintoutQrCodeNodeAttrs} from "./printoutQrCodeOptions";

const PrintoutQrCodeNodeView = (props: NodeViewProps) => {
    const attrs = getPrintoutQrCodeAttrs(props.node.attrs as PrintoutQrCodeNodeAttrs);
    const editable = props.editor.isEditable;

    // Preserve ProseMirror's DOM node but omit unconfigured QR blocks from print layout.
    if (!editable && !attrs.url) {
        return <NodeViewWrapper as="div" style={{display: "none"}}/>;
    }

    return (
        <PrintoutBlockShell
            {...props}
            blockType="printoutQrCode"
            icon={<QrCode2OutlinedIcon fontSize="small"/>}
            label="QR code"
        >
            <QrCodeView attrs={attrs}/>
        </PrintoutBlockShell>
    );
};

export default PrintoutQrCodeNodeView;
